<template>
  <vs-popup
    title="Transferir Atendimento"
    :active.sync="transferPopupIsActive"
    @close="closePopup"
    class="sizePopup"
    id="transferTicketPopUpSize"
  >
    <vs-card>
      <div class="flex" id="transfer-search-div">
          <vs-input
            @keydown.enter.prevent="fetchOnlineUsers()"
            placeholder="Buscar"
            v-model="search"
            class="mr-6"
          />
          <feather-icon
            id="icon-search"
            style="background-color:#279dfb; border-radius:6px; cursor:pointer; color:white; margin-bottom: 5px !important;"
            class="p-2"
            @click="fetchOnlineUsers()"
            icon="SearchIcon"
          />
      </div>
        <vs-table
          ref="transferTicketTable"
          noDataText="Nenhum usuário online"
          :max-items="itemsPerPage"
          :data="onlineUsers"
          :sst="true"
          @keydown.enter.prevent="fetchOnlineUsers()" 
          @selected="confirmChooseThisUser()"
          v-model="userSelected"
        >
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th>Nome</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>Departamento</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <vs-avatar :src="tr.image"></vs-avatar>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium">
                  {{ tr.name }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.email }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium">
                  {{ tr.userDepartment ? tr.userDepartment.name : '' }}
                </p>
              </vs-td>
            </vs-tr>

            </tbody>
          </template>

        </vs-table>
    </vs-card>

    <div v-if="canSee('transfer-to-inbox') && inboxActivated" class="inbox-container-div ml-0 mt-2 mb-4 d-flex items-center">
      <vs-button
        icon-pack="feather"
        icon="icon-inbox"
        class="inbox__inactive"
        type="flat"
        style="color: gray;"
        @click="transferToInbox = true"
      >
        <i class="ml-1"><b>Transferir para a Caixa de Entrada</b></i>
      </vs-button>
    </div>

    <div class="container-warning-transfer">
      <vs-alert
        active="true"
        class="mb-4"
      >
        <div class="flex flex-col items-start ml-2">
          <i> É possível transferir atendimentos apenas para usuários <b>online</b> e <b>vinculados à conexão atual. </b></i>
        </div>
      </vs-alert>
    </div>

    <vs-pagination
      :total="totalPages"
      v-model="page"
      :max="7"
    />

    <vs-popup
      title="Transferir para a Caixa de Entrada"
      :active.sync="transferToInbox"
      :button-close-hidden="true"
      @close="transferToInbox = false"
      style="z-index: 1000000"
    >
      <div class="w-full text-center d-flex justify-center items-center">
        <div>
          <div class="mb-1">
            <span class="text-sm mb-2">Vincular a um Departamento (opcional):</span>
          </div>

          <VuePerfectScrollbar
            style="height: 100px;"
            :key="$vs.rtl"
            ref="scrollRef"
            :settings="settings"
            class="vue-perfect-scrollbar-transfer-ticket-popup"
          >
            <v-select
              label="name"
              class="w-full"
              :reduce="departments => departments.id"
              v-model="departmentId"
              :options="userDepartments"
              @close="resetScroll"
            />
          </VuePerfectScrollbar>
        </div>
      </div>

      <vs-divider class="mt-0 mb-0"/>
      <div class="flex flex-wrap items-center mt-4">
        <vs-button class="mr-6 ml-auto" @click="triggerTransferToInbox">
          Transferir
        </vs-button>
        <vs-button type="border" color="danger" @click="transferToInbox = false">
          Cancelar
        </vs-button>
      </div>
    </vs-popup>
  </vs-popup>
</template>

<script>
import vSelect from 'vue-select';
import { hasPermission } from '@/utils';
import userRequests from '@/http/requests/user';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { transferChatTicket } from '@/http/requests/chatTicket';
import { transferManyChatTicket } from '@/http/requests/chatTicket';
import moduleUserDepartment from '@/store/userDepartment/moduleUserDepartment';

export default {
  data() {
    return {
      page: 1,
      totalPages: 4,
      itemsPerPage: 4,
      search: '',
      transferPopupIsActive: false,
      onlineUsers: [],
      userSelected: null,
      transferToInbox: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50
      },
      departmentId: null
    }
  },
  components: {
    vSelect,
    VuePerfectScrollbar
  },
  computed: {
    chatTicket() {
      return this.$store.state.chatContact.chatTransferPopup
    },
    user() {
      return this.$store.state.AppActiveUser
    },
    instanceId() {
      return this.chatTicket.instance_id || null
    },
    userDepartments() {
      return this.$store.state.userDepartment.userDepartments;
    },
    inboxActivated() {
      return !Boolean(Number(this.$store.state.settings.settings.relate_chat_tickets_to_next_user));
    }
  },
  watch: {
      search: function(newvalue) {
        if (newvalue === '') {
          this.fetchOnlineUsers();
        }
      },
      '$store.state.chatContact.transferPopupIsActive': async function (val) {
        if (val) {
          this.$vs.loading(
            {
              type: 'radius',
            }
          );

          this.transferPopupIsActive = val;
          await Promise.all(
            [
              this.fetchOnlineUsers()
                .then( () => this.$vs.loading.close() )
                .catch( () => this.$vs.loading.close() ),
              this.fetchDepartments()
            ]
          );

          await this.sleep(50);
        }
      },
      async page() {
        this.$vs.loading(
          {
            type: 'radius',
          }
        );

        await this.fetchOnlineUsers();
        this.$vs.loading.close();
      },
      totalPages () {
        this.page = 1;
      },
      transferToInbox(value) { if (!value) this.departmentId = null; }
    },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    resetScroll() {
      this.$refs.scrollRef.$el.scrollTop = 0;
    },
    closePopup() {
      this.onlineUsers = [];
      this.$store.dispatch('chatContact/changeStatusTransferPopupActive', false);
    },
    async fetchDepartments() {
      await this.$store.dispatch("userDepartment/fetch");
    },
    async fetchOnlineUsers(status = null) {
      let searchUser = null
      
      if (!status) {
        if (this.user.role.name !== 'administrador') {
          searchUser = this.user.id
        } else {
          searchUser = this.chatTicket.user.id
        }
      }

      await userRequests.fetchOnlineUsers(
        searchUser, 
        !status ? this.instanceId : null,
        this.page,
        this.itemsPerPage,
        this.search,
        null
      )
      .then(
        response => {
          this.onlineUsers = response.data.data.onlineUsers.items;
          this.totalPages  = response.data.data.onlineUsers.total_pages;
        }
      )
      .catch(
        error => {
          console.log(error);
          return this.$vs.notify(
            {
              color: 'danger',
              title: 'Houve algum erro ao carregar os usuários online!'
            }
          );
        }
      );
      this.$vs.loading.close();
    },
    async chooseUserToTransfer(chosenUserId) {
      this.$store.dispatch('chatContact/changeStatusTransferPopupActive', false);
      this.transferPopupIsActive = false;

      const user = this.onlineUsers.find( item => item.id === chosenUserId );
      await transferChatTicket(
        this.chatTicket.id,
        chosenUserId,
        user['userDepartment'] !== null ? user['userDepartment'].id : null
      );

      this.$store.dispatch('chatContact/changeSelectedCustomer', { customerId: null, instanceId: null });
      this.$emit('searchChats');

      this.$vs.notify(
        {
          color: 'success',
          title: 'Atendimento Transferido!',
          text: `O atendimento foi transferido com sucesso!`,
          time: 7000
        }
      );
    },
    confirmChooseThisUser() {
      return this.$vs.dialog({
        type:'confirm',
        color: 'primary',
        title: `Deseja continuar?`,
        text: `O atendimento será transferido para o usuário ${this.userSelected.name}.`,
        accept: async () => await this.chooseUserToTransfer(this.userSelected.id),
        cancel: () => this.userSelected = null,
        acceptText: 'Confirmar',
        cancelText: 'Voltar'
      })
    },
    async triggerTransferToInbox() {
      transferManyChatTicket(
        JSON.stringify([this.chatTicket.id]),
        null,
        this.departmentId
      )
      .then(
        () => {
          this.transferToInbox = false;
          this.$store.dispatch('chatContact/changeStatusTransferPopupActive', false);
          this.transferPopupIsActive = false;

          this.$vs.notify({
            color: 'success',
            title: 'Atendimento Transferido!',
            text: `O atendimento foi transferido com sucesso!`,
            time: 7000
          });
        }
      )
      .catch(
        error => {
          console.log(error);
          return this.$vs.notify(
            {
              color: 'danger',
              title: 'Houve algum erro ao efetuar a transferência!'
            }
          );
        }
      );
    },
    canSee(action) {
      return hasPermission(`${this.$route.name}-${action}`);
    }
  },
  created() {
    this.$parent.$on('closeAllPopUps', this.transferPopupIsActive = false);

    if (!moduleUserDepartment.isRegistered) {
      this.$store.registerModule('userDepartment', moduleUserDepartment);
      moduleUserDepartment.isRegistered = true;
    }
  },
  beforeDestroy() {
    this.$parent.$off('closeAllPopUps', this.transferPopupIsActive = false);
  }
}
</script>

<style lang="scss">
.vue-perfect-scrollbar-transfer-ticket-popup {
  position: relative;
  margin: auto;
  width: 100%;
  height: 23rem;
}
.con-vs-dialog {
  z-index: 529999 !important;
}
.inbox-container-div {
  .icon-inbox {
    font-size: 25px;
  }
}

#transferTicketPopUpSize div.vs-popup {
  width: 700px !important;
}

.container-warning-transfer {
  .con-vs-alert {
    height: auto!important;
  }
}

#transfer-search-div{
  justify-content: end;
  .vs-input--input.normal {
    border-radius: 20px !important;
  }

  .vs-con-input-label .vs-con-input {
    border-radius: 20px !important;
    margin-bottom: 5px !important;
  }
}
</style>